import { Modal } from "antd";
import { FaFileInvoiceDollar } from "react-icons/fa6";
import { PrepurchasedLicenseItemForm } from "./PrepurchasedLicenseItemForm";

const PrepurchasedLicenseItemModal = ({
  open,
  setOpen,
  giftCardId,
  editingItem,
  editingItemNo,
  existingItems,
  setEditingItem,
  itemsRefetch,
}) => {
  const handleClose = () => {
    setEditingItem(null);
    setOpen(false);
  };

  return (
    <Modal
      open={open}
      closable={false}
      onCancel={handleClose}
      footer={null}
      width={640}
      centered
      destroyOnClose
      title={
        <div className="flex items-center bg-gray-200 p-2 rounded-md">
          <FaFileInvoiceDollar className="text-[18px] text-black " />
          <span className="text-[14px] font-['Poppins'] text-black  ml-2">
            {editingItem?.ItemNo != null
              ? "Edit prepurchased license item"
              : "Add prepurchased license item"}
          </span>
        </div>
      }
    >
      {giftCardId ? (
        <PrepurchasedLicenseItemForm
          giftCardId={giftCardId}
          editingItem={editingItem}
          editingItemNo={editingItemNo}
          existingItems={existingItems}
          onCancel={handleClose}
          onSaved={itemsRefetch}
        />
      ) : null}
    </Modal>
  );
};

export default PrepurchasedLicenseItemModal;
